import { Divider, Alert } from "antd";
import React, { useContext } from "react";
import { AuthContext } from "../../../../contexts/auth/AuthContext";
import { canManageLogins } from "../../../../utils/loginRights";   // s88 (tog'a 2026-09-09, msg 1563)
import { useTranslation } from "react-i18next";
import SwitchSettings from "./SwitchSettings";
import PasswordUpdate from "./PasswordUpdate";
import DigestSettings from "./DigestSettings";   // tog'a #2504
import TwoFactorSettings from "./TwoFactorSettings";   // Tog'a #342 (katalog #6024): 2FA

export default function ProfileTab() {
  const { t } = useTranslation();
  const { authState } = useContext(AuthContext);
  const loginOk = canManageLogins(authState?.user);   // s88: huquqsiz foydalanuvchida parol oynasi yo'q

  return (
    <>
      <Divider orientation="left">{t("updatePassword")}</Divider>
      {loginOk ? <PasswordUpdate /> : <Alert type="info" showIcon message={t("loginRightsHint", "Парол ва логинни фақат бош администратор ёки ваколатли менежер беради")} />}
      <Divider orientation="left">🔐 {t("twoFactorTitle", "Двухэтапная проверка (Telegram)")}</Divider>
      <TwoFactorSettings />{/* Tog'a #342 (katalog #6024) */}
      <Divider orientation="left">{t("notifications")}</Divider>
      <SwitchSettings  />
      <Divider orientation="left">📊 {t("digestTitle", "Ежедневный отчёт")}</Divider>
      <DigestSettings />
    </>
  );
}
